export default {"src":"/_next/static/image/public/images/app_qr_code.89edd31369c0e9845527c1a5039ecc80.svg","height":174,"width":174};